import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { InputCount } from '../input-count/input-count';
import { IProductoCarritoData } from '@core/interfaces/entidades/productoCarrito.entidad';
import { CurrencyPipe } from '@angular/common';
import { CarritoCompraService } from '@shared/services/carrito-compra.service';

@Component({
  selector: 'app-carrito-compra-producto',
  imports: [CurrencyPipe, InputCount],
  templateUrl: './carrito-compra-producto.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './carrito-compra-producto.css',
})
export class CarritoCompraProducto {
  productoCarrito = input.required<IProductoCarritoData>();

  precioTotal(): number {
    return this.productoCarrito().cantidad * this.productoCarrito().precio;
  }

  private carritoCompraService = inject(CarritoCompraService);
  eliminarProducto() {
    this.carritoCompraService.eliminar(this.productoCarrito());
  }
}
